import { FrameName } from "../config";
import SmallHousesBuildingTileEntity from "./SmallHousesBuildingTileEntity";

class MediumHousesBuildingTileEntity extends SmallHousesBuildingTileEntity {
	public static readonly frameName = FrameName.MEDIUM_HOUSES;
}

export default MediumHousesBuildingTileEntity;
